export const aboutInfo = {
  brandName: '红桃影视',
  brandIntro: '红桃影视成立于2020年，是国内领先的高清影视资源在线观看平台。我们致力于为用户提供海量正版高清影视内容，涵盖电影、电视剧、综艺、动漫、纪录片等全品类资源。凭借强大的技术团队和丰富的行业经验，红桃影视已为数千万用户提供了优质的在线观影服务。',
  mission: '让每一位用户都能随时随地享受高清影视带来的视听盛宴。',
  vision: '成为中国最受用户信赖和喜爱的在线影视平台。',
  stats: [
    { label: '累计用户', value: '5000万+' },
    { label: '影视资源', value: '10万+' },
    { label: '日均更新', value: '200+' },
    { label: '用户好评率', value: '98.5%' },
  ],
};

export const testimonials = [
  {
    id: 1,
    name: '张先生',
    role: '资深影迷',
    content: '红桃影视的片源更新速度真的很快，画质也非常清晰。用了两年多了，一直是我的首选观影平台。',
    rating: 5,
  },
  {
    id: 2,
    name: '李女士',
    role: '家庭用户',
    content: '家里老人小孩都爱看，分类很清晰，操作也简单。特别是动漫频道，孩子特别喜欢。',
    rating: 5,
  },
  {
    id: 3,
    name: '王同学',
    role: '大学生',
    content: '宿舍追剧必备！资源全、播放流畅，而且免费内容也很多，学生党表示很友好。',
    rating: 5,
  },
  {
    id: 4,
    name: '赵女士',
    role: '职场白领',
    content: '下班后的放松神器。高清画质看着很舒服，多端同步的功能也很方便，手机和电视无缝切换。',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '红桃影视是否需要注册才能观看？',
    answer: '部分免费内容无需注册即可观看。注册成为会员后，可以享受更多高清资源和专属功能，包括离线下载、无广告观看等特权。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '红桃影视支持手机（iOS/Android）、平板、电脑网页端以及智能电视等多终端观看。您可以在不同设备间无缝切换，观看记录自动同步。',
  },
  {
    question: '视频画质如何？',
    answer: '红桃影视提供从标清到4K超清的多种画质选择。大部分影视资源支持1080P高清播放，部分精选内容支持4K超清画质，您可以根据网络状况自由切换。',
  },
  {
    question: '是否有广告？',
    answer: '免费用户观看时会看到少量贴片广告。会员用户享受无广告纯净观影体验，同时还享有更多专属权益。',
  },
  {
    question: '如何下载红桃影视APP？',
    answer: '您可以在苹果App Store或各大安卓应用市场搜索"红桃影视"下载官方APP。也可以在官网首页扫描二维码直接下载。',
  },
];

export const contactInfo = {
  email: 'contact@hongtaomovies.com',
  phone: '400-888-6666',
  address: '北京市朝阳区望京科技园红桃影视大厦',
  wechat: '红桃影视官方',
  weibo: '@红桃影视',
  workHours: '周一至周日 9:00 - 21:00',
};